import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Paginate from 'vue-paginate'
import VueQuillEditor from 'vue-quill-editor'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VeeValidate from 'vee-validate'
import CxltToastr from 'cxlt-vue2-toastr'
import FileUpload from 'vue-upload-component'
import VueMask from 'di-vue-mask'
import VMoney from 'v-money'
import PrettyCheckbox from 'pretty-checkbox-vue'
import VueScrollTo from 'vue-scrollto'
import Vue2Filters from 'vue2-filters'
import Datetime from 'vue-datetime'
import vSelect from 'vue-select'
import VueJsonTreeView from 'vue-json-tree-view'
import VueHtmlToPaper from 'vue-html-to-paper'
import VueYouTubeEmbed from 'vue-youtube-embed'
import {SliderPlugin} from '@syncfusion/ej2-vue-inputs'
import vClickOutside from 'v-click-outside'
import VueGtag from 'vue-gtag'

import store from './store/'
import router from './router/'
import UiMixin from './mixin'
import VueTabs from 'vue-nav-tabs'
import components from './components'
import filters from './filter'

import ImportacaoDataConsigHub from '@/service/websocket/importacaoDataConsigHub'
import UsuariosHub from '@/service/websocket/usuariosHub'
import LeadsHub from '@/service/websocket/leadsHub'
import ListagensHub from '@/service/websocket/listagensHub'

import './service/atividade'
import 'font-awesome/css/font-awesome.min.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'pretty-checkbox/src/pretty-checkbox.scss'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-nav-tabs/themes/vue-tabs.css'
import './scss/style.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../node_modules/@syncfusion/ej2-buttons/styles/material.css'
import '../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css'

const toastrConfigs = { showMethod: 'fadeInDown', hideMethod: 'fadeOut', position: 'top right', showDuration: 1000, hideDuration: 1000, delay: 100, timeOut: 4000 }

// Use
Vue.use(BootstrapVue)
Vue.use(Paginate)
Vue.use(VueQuillEditor)
Vue.use(VueMoment, {
  moment
})
Vue.use(VeeValidate, { inject: true, fieldsBagName: 'veeFields' })
Vue.use(VueMask)
Vue.use(VMoney)
Vue.use(PrettyCheckbox)
Vue.use(VueScrollTo)
Vue.use(Vue2Filters)
Vue.use(VueTabs)
Vue.use(UiMixin)
Vue.use(CxltToastr, toastrConfigs)
Vue.use(Datetime)
Vue.use(VueJsonTreeView)
Vue.component('UiFileUpload', FileUpload)
Vue.component('vSelect', vSelect)
Vue.use(VueHtmlToPaper)
Vue.use(VueYouTubeEmbed)
Vue.use(SliderPlugin)
Vue.use(vClickOutside)
Vue.use(ImportacaoDataConsigHub)
Vue.use(UsuariosHub)
Vue.use(LeadsHub)
Vue.use(ListagensHub)

if (process.env.SISTEMA.indexOf('prod') >= 0) {
  Vue.use(VueGtag, {
    config: { id: 'G-VST195DMMF' }
  })
}

// Components e Filters
Vue.mixin({ components, filters })

export default { store, router }



// WEBPACK FOOTER //
// ./src/imports.js